export default "__VITE_ASSET__81279368__"